import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 36 36" version="1.1">
        <g id="Style-guide" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="nifty-UI-guide" transform="translate(-756.000000, -3291.000000)" fill={color}>
                <g id="Group-6" transform="translate(713.000000, 3248.000000)">
                    <path d="M61,79 C51.0588745,79 43,70.9411255 43,61 C43,51.0588745 51.0588745,43 61,43 C70.9411255,43 79,51.0588745 79,61 C79,70.9411255 70.9411255,79 61,79 Z M61,75.4 C68.9529004,75.4 75.4,68.9529004 75.4,61 C75.4,53.0470996 68.9529004,46.6 61,46.6 C53.0470996,46.6 46.6,53.0470996 46.6,61 C46.6,68.9529004 53.0470996,75.4 61,75.4 Z M57.0272078,67.6727922 L51.6272078,62.2727922 C50.9242641,61.5698485 50.9242641,60.4301515 51.6272078,59.7272078 C52.3301515,59.0242641 53.4698485,59.0242641 54.1727922,59.7272078 L58.3,63.8797652 L66.9272078,55.2272078 C67.6301515,54.5242641 68.7698485,54.5242641 69.4727922,55.2272078 C70.1757359,55.9301515 70.1757359,57.0698485 69.4727922,57.7727922 L59.5727922,67.6727922 C58.8698485,68.3757359 57.7301515,68.3757359 57.0272078,67.6727922 Z" id="Combined-Shape"></path>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconCheckCircled extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
